import { CheckCircle } from 'lucide-react'
import { Button } from '../../../components/ui/button'
import { useNavigate } from 'react-router-dom'

const RegisterApproved = () => {
  const navigate = useNavigate()

  const handleGoToLogin = () => {
    navigate('/')
  }

  return (
    <div className="flex flex-col items-center justify-center gap-4 px-4 text-black03 sm:gap-6">
      <div className="flex max-w-md flex-col items-center gap-3 text-center sm:gap-4">
        <CheckCircle className="h-12 w-12 text-green-500 sm:h-16 sm:w-16" />
        <h2 className="text-lg font-semibold text-green-600 sm:text-2xl">
          Cadastro Aprovado
        </h2>
        <p className="text-xs leading-relaxed sm:text-sm">
          Parabéns! Seu cadastro foi aprovado com sucesso. Bem-vindo à nossa
          comunidade!
        </p>

        <Button
          type="button"
          onClick={handleGoToLogin}
          className="mt-2 h-11 w-full bg-primary px-6 text-sm text-white hover:bg-primary/90 sm:mt-4 sm:h-12 sm:w-auto sm:px-8 sm:text-base"
        >
          Continue
        </Button>
      </div>
    </div>
  )
}

export default RegisterApproved
